<template>
  <div class="page">
    <div class="breadcrumb">
      <router-link to="/home">上海盛目实业集团有限公司</router-link>
      <span>></span>
      <router-link to="/cooperation">合作伙伴</router-link>
    </div>
    <div class="logo-box">
      <div class="title">
        <p>合作伙伴</p>
      </div>
      <div class="logo-box-list">
        <div class="item" v-for="item in cooperation" :key="item.id">
          <div class="item-box">
            <img :src="item.logo" alt="">
          </div>
          <img src="@/assets/02.png" alt="">
        </div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {}
  },
  created() {
    this.getCooperation()
  },
  computed: {
    ...mapGetters(['cooperation'])
  },
  methods: {
    ...mapActions('data', { getCooperation: 'getCooperation' }),
    handleTime(time) {
      return this.$moment(time).format('YYYY-MM,DD')
    }
  }
}
</script>

<style lang="scss" scoped>
$page-center: 1200px;
.page {
  width: $page-center;
  margin: auto;
  img {
    width: 100%;
  }
  .breadcrumb {
    margin: 30px auto 80px;
  }
  .logo-box {
    border: 1px solid #999;
    box-shadow: 0 0 10px #ccc;
    margin-bottom: 40px;
    .title {
      padding: 40px 0 20px;
      width: 80%;
      margin: auto;
      text-align: center;
      font-size: 28px;
      font-weight: 700;
      border-bottom: 2px solid #999;
    }
    &-list {
      width: 80%;
      margin: auto;
      padding: 80px 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 19%;
        position: relative;
        margin-bottom: 20px;
        &-box {
          position: absolute;
          width: 70%;
          height: calc(100% - 2px);
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: auto;
            max-width: 100%;
            max-height: 80%;
          }
        }
      }
    }
  }
}
</style>
